module.exports = __webpack_public_path__ + "static/media/S3.7dc17c41.webp";